// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__+N5eH","hour":"Loader_hour__0UdKo","min":"Loader_min__kUIvk","load9243":"Loader_load9243__fR6qN","circel":"Loader_circel__0fjr6"};